import { Checkbox } from "@/shared/components/ui/checkbox";
import { Button } from "@/shared/components/ui/button";
import { Pencil } from "lucide-react";

interface OrdersBulkActionBarProps {
  selectedCount: number;
  onDeselectAll: () => void;
  onChangeDates: () => void;
}

export function OrdersBulkActionBar({
  selectedCount,
  onDeselectAll,
  onChangeDates,
}: OrdersBulkActionBarProps) {
  return (
    <div
      className="flex items-center gap-4 mb-4 min-h-[48px] pl-4"
      style={{ visibility: selectedCount > 0 ? "visible" : "hidden" }}
    >
      <div className="flex items-center gap-2 px-4">
        <Checkbox checked={true} onCheckedChange={() => onDeselectAll()} />
        <span className="text-sm">Выбрано заказов — {selectedCount}</span>
      </div>
      <Button variant="outline" size="sm" onClick={onChangeDates}>
        <Pencil className="w-4 h-4 mr-2" />
        Изменить дату
      </Button>
    </div>
  );
}
